import type { CoworkMissKind, CoworkMissOrigin, CoworkMissStatus, CoworkThreadEvent } from '@/api/adminClient';

export const KIND_LABELS: Record<CoworkMissKind, string> = {
  missing_source: 'Missing source',
  missing_body: 'Missing body',
  wrong_answer: 'Wrong answer',
  feature: 'Feature',
  other: 'Other',
};

export const ORIGIN_LABELS: Record<CoworkMissOrigin, string> = {
  report_gap: "What we don't have",
  follow_up: 'Unanswered follow-up',
  decision: 'Was this useful?',
  ask: 'They said',
};

export const STATUSES: CoworkMissStatus[] = ['new', 'seen', 'done'];

export function coworkSessionPath(sessionId: string): string {
  return `/cowork/sessions/${encodeURIComponent(sessionId)}`;
}

export interface ThreadLine {
  key: number;
  at: string;
  who: string;
  text: string;
}

const DECISION_WORDS: Record<string, string> = { used: 'Used it', changed: 'Changed it first', rejected: "Didn't use it" };

function words(value: unknown): string {
  return typeof value === 'string' ? value : '';
}

/** One stored event as a line of the thread, or null for one a reader has no use for. */
export function threadLine({ seq, at, event }: CoworkThreadEvent): ThreadLine | null {
  const line = (who: string, text: string) => (text ? { key: seq, at, who, text } : null);
  switch (event.type) {
    case 'user_message': return line('They asked', words(event.text));
    case 'assistant_message': return line('Cowork', words(event.text));
    case 'artifact_version_published': return line('Report', `v${String(event.version)}: ${words(event.title)}`);
    case 'decision_recorded': return line('Was this useful?', `v${String(event.version)}: ${DECISION_WORDS[words(event.decision)] ?? words(event.decision)}`);
    case 'ask_received': return line('They wanted', words(event.text));
    case 'ask_confirmed': return line('Cowork', words(event.confirmation));
    case 'stopped': return line('Stopped', words(event.reason));
    case 'error': return line('Error', words(event.message));
    default: return null;
  }
}
